import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  ShiftTemplateSettingsItem,
  ShiftTemplatesSettingsResponse,
} from "@/actions/ssr/settings/getShiftTemplatesSettingsSSR";

interface SettingsShiftTemplatesState {
  items: ShiftTemplateSettingsItem[];
  totalPages: number;
  currentPage: number;
  totalItems: number;
}

const initialState: SettingsShiftTemplatesState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const settingsShiftTemplatesSlice = createSlice({
  name: "settingsShiftTemplates",
  initialState,
  reducers: {
    setSettingsShiftTemplates(
      state,
      action: PayloadAction<ShiftTemplatesSettingsResponse | null>,
    ) {
      if (!action.payload) return;
      state.items = action.payload.results;
      state.totalPages = action.payload.total_pages;
      state.currentPage = action.payload.current_page;
      state.totalItems = action.payload.count;
    },
    setSettingsShiftTemplateItems(
      state,
      action: PayloadAction<ShiftTemplateSettingsItem[]>,
    ) {
      state.items = action.payload;
    },
    setSettingsShiftTemplatePagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        totalItems?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.totalItems !== undefined) {
        state.totalItems = action.payload.totalItems;
      }
    },
  },
});

export const {
  setSettingsShiftTemplates,
  setSettingsShiftTemplateItems,
  setSettingsShiftTemplatePagination,
} = settingsShiftTemplatesSlice.actions;
export default settingsShiftTemplatesSlice.reducer;
